// extracted by mini-css-extract-plugin
export default {"root":"ErrorMessage_root__Kv7It","medium":"ErrorMessage_medium__aYkW4","large":"ErrorMessage_large__Oeu1N"};